import React from 'react';
import { Div, H3, Button, A } from 'glamorous';

import { theme } from '../theme';
import Logo from '../Logo/Logo';

const Hero = props => (
  <Div
    css={{
      padding: theme.gutter,
    }}
  >
    <Logo
      css={{
        display: 'block',
        margin: '0 auto',
        width: '50vw',
        maxWidth: '40rem',
        height: 'auto',
        paddingTop: theme.gutter,
        paddingBottom: theme.gutter,
        '@media(max-width: 26.67rem)': {
          width: '60vw',
        },
      }}
      color={theme.brandRed}
      swordColor={theme.textColor}
    />
    <H3
      css={{
        textAlign: 'center',
      }}
    >
      software + spatial development services
    </H3>

    <Div css={{ display: 'block', padding: theme.gutter, textAlign: 'center' }}>
      <A
        href="mailto:tim@redronin.io"
        css={{
          ':hover': {
            boxShadow: 'none',
          },
        }}
      >
        <Button
          css={{
            padding: '0.5rem 1rem',
            backgroundColor: theme.brandRed,
            borderRadius: '1rem',
            border: 'none',
            color: theme.textColor,
            transition: `box-shadow,background-color ${theme.transition}`,
            ':hover': {
              cursor: 'pointer',
              backgroundColor: theme.brandRedHover,
              boxShadow: '1px 2px 10px hsla(0, 0%, 100%, 0.2)',
              transition: `box-shadow, background-color ${theme.transition}`,
            },
            '@media(max-width: 26.67rem)': {
              fontSize: '1.25rem',
            },
          }}
        >
          Contact Us
        </Button>
      </A>
    </Div>
  </Div>
);

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero/Hero.js